export default __webpack_public_path__ + "static/media/personal-helper.2c1d4bf8.svg";